export default __webpack_public_path__ + "static/media/5.1e0868ae.png";